import addSurgicalOrderIcon from 'presentation/assets/icons/add-surgical-order.svg'
// TO-DO: uncomment when budget request is live
// import requestBudgetIcon from 'presentation/assets/icons/budgets-light.svg'
// TO-DO: uncomment when exams and surgicals is live
// import examsAndSurgicalsIcon from 'presentation/assets/icons/exams-and-surgicals-light.svg'
// TO-DO: uncomment when service solicitation is live
// import serviceOrderIcon from 'presentation/assets/icons/service-order-light.svg'
import makeAnAppointment from 'presentation/assets/icons/exams-and-surgicals-light.svg'
import doctorIcon from 'presentation/assets/icons/doctor-icon.svg'
import addExam from 'presentation/assets/icons/add-exam.svg'

type OptionsType = {
  link: string
  label: string
  icon: string
}

type ProfilesType = {
  doctor: OptionsType[]
  patient: OptionsType[]
  admin: OptionsType[]
  secretary: OptionsType[]
  crmo: OptionsType[]
  hospitalization: OptionsType[]
  doctor_register: OptionsType[]
  director_doctor_register: OptionsType[]
  admin_sectorial_crmo: OptionsType[]
}

const profiles: ProfilesType = {
  doctor: [
    {
      link: '/pedido/novo',
      label: 'Novo pedido cirúrgico',
      icon: doctorIcon
    },
    // TO-DO: uncomment when doctor channel is live
    // {
    //   link: '/home',
    //   label: 'Canal médico',
    //   icon: doctorIcon
    // },
    {
      link: '/vincular-profissional',
      label: 'Adicionar Secretária',
      icon: doctorIcon
    }
  ],
  patient: [
    {
      link: '/pedido-cirurgico',
      label: 'Solicitar pedido cirúrgico',
      icon: addSurgicalOrderIcon
    },
    {
      link: '',
      label: 'Marcar consulta',
      icon: makeAnAppointment
    },
    {
      link: '/novo-exame',
      label: 'Agendar exame',
      icon: addExam
    }
    // TO-DO: uncomment when budget request is live
    // {
    //   link: '/home',
    //   label: 'Solicitar orçamento',
    //   icon: requestBudgetIcon
    // },
    // TO-DO: uncomment when exams and surgical is live
    // {
    //   link: '/vincular-profissional',
    //   label: 'Consultas e exames',
    //   icon: examsAndSurgicalsIcon
    // }
    // TO-DO: uncomment when service solicitation is live
    // {
    //   link: '/vincular-profissional',
    //   label: 'Solicitar serviço',
    //   icon: serviceOrderIcon
    // }
  ],
  admin: [],
  secretary: [],
  crmo: [],
  hospitalization: [],
  doctor_register: [],
  director_doctor_register: [],
  admin_sectorial_crmo: []
}

export default profiles
